module.exports = __webpack_public_path__ + "img/smtp.1fceee67.jpg";